import { IncError } from "@core/domain/errors/inc.error";

export class HttpRejectedRequestError extends IncError {
    constructor(message: string) {
        super(message);

        Object.setPrototypeOf(this, HttpRejectedRequestError.prototype);
    }
}
